import { spaceCadet } from '@cogneed/react-utils';
import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)({
  '& a': {
    border: `1px solid${spaceCadet[300]}`,
    padding: 8,
    borderRadius: 8,
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    justifyContent: 'flex-start',
    textDecoration: 'none',

    '& img': {
      height: 30,
      width: 30,
      display: 'block',
    },
    '& .MuiTypography-h2': {
      marginTop: 2,
      fontSize: 14,
      fontWeight: 600,
      lineHeight: 1,
      color: spaceCadet[800],
    },
    '& .MuiTypography-caption': {
      fontSize: 12,
      color: spaceCadet[400],
    },
    '& svg': {
      fontSize: 16,
      display: 'block',
    },

    '& strong': {
      display: 'block',
    },
  },
});

export default StyledBox;
